import { connect } from "react-redux";

import { FullFormState } from "../../../../Engine/Core/Store/FullFormState";

import { TemplatesModal } from "./TemplatesModal";

const mapStateToProps = (state: FullFormState) => ({
    gfv: state.settings.gfv,
    draftId: state.settings.draftId,
});

export const TemplatesModalContainer = connect(mapStateToProps)(TemplatesModal);
